const { translateString } = window.BAO.Utils

class TastemakerProductCount extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.static) {
      return
    }

    this.render()
  }

  setupListeners () {
    super.setupListeners()

    if (this.static) {
      return
    }

    if (this.tastemakersManager) {
      this.tastemakersManager.on('update', this.render.bind(this))
    }
  }

  render () {
    this.textContent = translateString(this.template, { count: this.count })
  }

  get tastemakersManager () {
    return window.BAO?.Tastemakers?.manager
  }

  get count () {
    return this.tastemakersManager?.items.size
  }

  get static () {
    return this.getAttribute('static') === 'true'
  }

  get template () {
    return this.getAttribute('template')
  }
}

if (!window.customElements.get('tastemaker-product-count')) {
  window.customElements.define(
    'tastemaker-product-count',
    TastemakerProductCount,
  )
}
